import React from "react";
import {
  green_container,
  flex_container,
  flex_div,
  desktop_container,
} from "../about.module.scss";
import AnimatedCounter from "./AnimatedCounter";
import { InView } from "react-intersection-observer";
import fb_insta from "../../../../images/icons/fb_insta.png"

const GreenCounterContainer = () => {
  return (
    <InView>
      {({ inView, ref, entry }) => (
        <div ref={ref}>
          <div className={green_container}>
            <div className={desktop_container}>
              <h2 data-sal="fade" data-sal-delay="100" data-sal-duration="1000">
                Comunidad
              </h2>
              <div
                data-sal="fade"
                data-sal-delay="100"
                data-sal-duration="1000"
                className={flex_container}
              >
                <div style={{ borderRight: "2px solid whitesmoke" }}>
                  <h3>
                    +
                    <AnimatedCounter
                      inView={inView}
                      number="30000"
                      duration="4"
                    />
                  </h3>
                  <div className={flex_div}>
                    <p>kolyers</p>
                    <img src={fb_insta} alt="kolyy social media" />
                  </div>
                </div>
                <div>
                  <h3>
                    +
                    <AnimatedCounter
                      inView={inView}
                      number="15000"
                      duration="4"
                    />
                  </h3>
                  <p>kolyers con placa identificativa</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </InView>
  );
};

export default GreenCounterContainer;
